module.exports = __webpack_public_path__ + "static/img/homepages.115aafa5.svg";